<template>
  <v-select
    class="base-dropdown inherit--font"
    flat
    hide-no-data
    menu-icon="mdi:mdi-chevron-down"
    :menu-props="{
      maxWidth: 260
    }"
    v-bind="$attrs"
  >
    <template v-for="(_, slot) in $slots" #[slot]>
      <slot :name="slot" />
    </template>
    <template v-if="required" #label>
      <span class="d-inline-flex align-center">
        {{ $attrs.label }} *
      </span>
    </template>
  </v-select>
</template>
<script setup lang="ts">
import { VSelect } from 'vuetify/components'

defineProps<{
  required?: boolean
}>()
const $slots = defineSlots<Record<string, any>>()
</script>
